module.exports = __webpack_public_path__ + "static/media/Portrait-10037.8f6ec366.jpg";